module.exports = __webpack_public_path__ + "static/media/letter-2-min.58b3265e.png";